import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useMutation, useQueryClient } from "react-query";
import { designControlsApi } from "../../api/designControls";
import {
  Policy,
  RequirementLevels,
  TestCaseLevels,
} from "@design-controls/types";
import { useCurrentConfigs } from "../useCurrentConfigs";

export const useDeletePolicy = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const config = useCurrentConfigs();
  const { showToast } = useToastProvider();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (type: Policy["type"]) => {
      if (
        type == RequirementLevels.requirement2 &&
        config.find((item) => item.type == TestCaseLevels.testCase2)
      ) {
        designControlsApi.deletePolicy(
          companyId,
          productId,
          TestCaseLevels.testCase2,
        );
      } else if (
        type == RequirementLevels.requirement3 &&
        config.find((item) => item.type == TestCaseLevels.testCase3)
      ) {
        designControlsApi.deletePolicy(
          companyId,
          productId,
          TestCaseLevels.testCase3,
        );
      }
      return designControlsApi.deletePolicy(companyId, productId, type);
    },
    onSuccess: async () => {
      await client.invalidateQueries(["PRODUCT_CONFIGS", companyId, productId]);
      showToast({
        title: "Success",
        description: "Changes saved to product configuration",
        status: "success",
      });
    },
    onError: () => {
      showToast({
        title: "Error",
        description: "Failed to save changes. Please try again.",
        status: "error",
      });
    },
  });
};
